import React, { Component } from 'react';
import { StepPage } from '../../controls/StepPage';
import { DealerView } from '../DealerView';


export class CustomizedStep1Page extends StepPage {

    constructor(props) {
        super(props);
        this.dealerRef = React.createRef();
    }

    validate() {
        var result = this.dealerRef.current.validate();
        if (!result.state) {
            return result;
        }
        return { state: true, msg: "validate success" };
    }
    render() {
        let model = this.props.model;
        if (!model) {
            return null;
        }

        return <div className="flex gap-4">
            <DealerView model={model.dealerInfo} company={model.productBrand} ref={this.dealerRef} classnames="w-9/12" />
        </div>
    }
}